import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SunsetBandsProps {
  className?: string;
  heights?: [string, string, string, string];
}
export function SunsetBands({
  className,
  heights = ['h-1.5', 'h-1.5', 'h-1.5', 'h-1.5']
}: SunsetBandsProps) {
  return <div className={cn('w-full flex flex-col', className)} data-id="element-248">
      <div className={cn('w-full bg-brand-amber', heights[0])} data-id="element-249" />
      <div className={cn('w-full bg-brand-orange', heights[1])} data-id="element-250" />
      <div className={cn('w-full bg-brand-tan', heights[2])} data-id="element-251" />
      <div className={cn('w-full bg-brand-brown', heights[3])} data-id="element-252" />
    </div>;
}